import { createSlice } from "@reduxjs/toolkit";

export const securitySettingSlice = createSlice({
  name: "securitySetting",
  initialState: {
    getSecuritySettingResult: false,
    getSecuritySettingLoading: false,
    getSecuritySettingError: false,
    addSecuritySettingResult: false,
    addSecuritySettingLoading: false,
  },
  reducers: {
    securitySettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_SECURITYSETTING":
          return {
            ...state,
            getSecuritySettingResult: payload.data,
            getSecuritySettingLoading: payload.loading,
            getSecuritySettingError: payload.error,
          };
        case "ADD_SECURITYSETTING":
          return {
            ...state,
            addSecuritySettingResult: payload.data,
            addSecuritySettingLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { securitySettingReducers } = securitySettingSlice.actions;

export default securitySettingSlice.reducer;
